import op from 'object-path';
import { mapGetters } from 'vuex';
import { checkForMeasurementError } from '@/modules/utils';

const MEASUREMENTS = [
  { key: 'Collar Circumference', nameKey: 'neck' },
  { key: 'Chest Circumference', nameKey: 'chest' },
  { key: 'Center Back Neck to Crotch Length', nameKey: 'torso' },
  { key: 'Narrow Waist Circumference', nameKey: 'mid_waist' },
  { key: 'Low Hip Circumference', nameKey: 'hip' },
  { key: 'Back Cross Shoulder Width', nameKey: 'shoulder' },
  { key: 'Left Upper Arm Circumference', nameKey: 'biceps' },
  { key: 'Left Arm Length', nameKey: 'arm' },
  { key: 'Left Thigh Circumference', nameKey: 'thigh' },
  { key: 'Left Inseam Length', nameKey: 'inner_leg' },
];


const measurements = {
  beforeDestroy() {
    this.stopAutoplay();
  },
  data: () => ({
    useInch: false,
    activeMeasurementIndex: -1,
    currentMeasurement: null,
    measurements: [],
    measurementFailed: false,
  }),
  methods: {
    processMeasurements(data, skipError = false, onlyProcess = false, customMeasurement = null) {
      const { error, measurement, alg_ver: algVer } = data;
      const errors = checkForMeasurementError(error);
      if (errors.length > 0) {
        this.measurementFailed = true;
        if (!skipError) {
          throw new Error(`measurement failed, errors: ${errors.join(', ')}`);
        }
      }
      const target = customMeasurement || MEASUREMENTS;
      const selectedMeasurements = target.map(m => {
        const { key, rightKey, ...extra } = m;
        const measure = { ...op.get(measurement, `${m.key}.${m.subKey || 'origin'}`, {}), ...m, algVer };
        measure.rightMes = rightKey ? { ...op.get(measurement, `${rightKey}.${m.subKey || 'origin'}`, {}), key: rightKey, ...extra, algVer } : null;
        if (measure.rightMes?.view === 'left') measure.rightMes.view = 'right';
        else if (measure.rightMes?.view === 'right') measure.rightMes.view = 'left';
        return measure;
      });

      if (this.isFemale) {
        selectedMeasurements.find(m => m.key === 'Chest Circumference').nameKey = 'chest_female';
      }
      selectedMeasurements.forEach(m => {
        if (!m.key) {
          console.log(`[ERROR] something wrong with this measurement: ${JSON.stringify(m)}`);
        }
      });
      if (onlyProcess) return selectedMeasurements;
      this.measurements = selectedMeasurements;
      this.$store.commit('user/SET_MEASUREMENTS', selectedMeasurements);
      return null;
    },
    autoplayMeasurements() {
      this.autoplayTimer = setTimeout(() => {
        const total = this.measurements.length;
        if (!total) return;

        this.activeMeasurementIndex =
          this.activeMeasurementIndex >= total - 1 ? 0 : this.activeMeasurementIndex + 1;
        const next = this.measurements[this.activeMeasurementIndex];
        this.setCurrentMeasurement(next);
        this.autoplayMeasurements();
      }, 3000);
    },
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },
    onUnitSwitch(useInch) {
      this.useInch = useInch;
    },
    setCurrentMeasurement(measurement) {
      this.currentMeasurement = measurement;
    },
  },
  computed: {
    ...mapGetters('user', ['isMale', 'isFemale']),
    leftMeasurements() {
      return this.measurements
        .slice(0, 5)
        .map(m => ({ ...m, name: this.$t(`measurement.${m.nameKey}`) }));
    },
    rightMeasurements() {
      return this.measurements
        .slice(5, 10)
        .map(m => ({ ...m, name: this.$t(`measurement.${m.nameKey}`) }));
    },
    hasMeasurements() {
      return this.measurements.length > 0;
    },
  },
};

export default measurements;
